module.exports = __webpack_public_path__ + "img/notifications-intro.e58c1de7.png";